import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SwiperModule } from 'swiper/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';

import { LoginPageModule } from '@ideabytes/groupbenefitz_common_ui';
import { OrderServicesCarouselModule } from '@ideabytes/groupbenefitz_common_ui';
import { SharedLoaderService } from '@ideabytes/groupbenefitz_common_ui';
import { LoaderService } from './services/loader.service';

import { AppRoutingModule } from './app-routing.module';
import { HttpInterceptorService } from './http.interceptor';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { OverviewComponent } from './overview/overview.component';
import { WelcomeBarComponent } from './welcome-bar/welcome-bar.component';
import { UpdateAddressComponent } from './update-address/update-address.component';
import { LoaderComponent } from "./loader.component";
import { PagesLoginWithTokenComponent } from './pages-login-with-token-component/pages-login-with-token-component.component';
import { QuestionsComponent } from './questions/questions.component';
import { UpgradePlansComponent } from './upgrade-plans/upgrade-plans.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AddDependentComponent } from './add-dependent/add-dependent.component';
import { BookingComponent } from './booking/booking.component';
import { SigninComponent } from './signin/signin.component';
import { ChatComponent } from './chat/chat.component';

import { PhoneNoFormatPipe } from './pipes/phone-no-format.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { DatepickerTypedInputDirective } from './directives/datepicker-typed-input.directive';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    FooterComponent,
    SideBarComponent,
    HomeComponent,
    HeaderComponent,
    OverviewComponent,
    WelcomeBarComponent,
    UpdateAddressComponent,
    PhoneNoFormatPipe,
    CustomDatePipe,
    DatepickerTypedInputDirective,
    PagesLoginWithTokenComponent,
    QuestionsComponent,
    UpgradePlansComponent,
    ResetPasswordComponent,
    AddDependentComponent,
    BookingComponent,
    SigninComponent,
    ChatComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    PdfViewerModule,
    SignaturePadModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SwiperModule,
    LoginPageModule,
    OrderServicesCarouselModule,
    RxReactiveFormsModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },  { provide: SharedLoaderService, useExisting: LoaderService },],
  bootstrap: [AppComponent]
})
export class AppModule { }
